import { render, staticRenderFns } from "./general-value-diff.vue?vue&type=template&id=1f7f2b74&"
import script from "./general-value-diff.vue?vue&type=script&lang=js&"
export * from "./general-value-diff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f7f2b74')) {
      api.createRecord('1f7f2b74', component.options)
    } else {
      api.reload('1f7f2b74', component.options)
    }
    module.hot.accept("./general-value-diff.vue?vue&type=template&id=1f7f2b74&", function () {
      api.rerender('1f7f2b74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/general-value-diff.vue"
export default component.exports